import { graphql } from '@/gql';

export const allTemplates = graphql(`
  query allTemplates {
    templates {
      id
      name
      description
      publicationStatus
      createdAt
      updatedAt
      businessUnit
      owner {
        id
        name
      }
    }
  }
`);

export const createTemplate = graphql(`
  mutation createTemplate($createTemplateInput: CreateTemplateInput!) {
    createTemplate(createTemplateInput: $createTemplateInput) {
      id
    }
  }
`);

export const updateTemplate = graphql(`
  mutation updateTemplate($updateTemplateInput: UpdateTemplateInput!) {
    updateTemplate(updatedTemplate: $updateTemplateInput) {
      id
    }
  }
`);

export const deleteTemplate = graphql(`
  mutation deleteTemplate($id: ID!) {
    deleteTemplate(id: $id) {
      id
    }
  }
`);

export const getTemplate = graphql(`
  query getTemplate($id: ID!) {
    template(id: $id) {
      id
      businessUnit
      name
      updatedAt
      description
      publicationStatus
      owner {
        id
        name
      }
      basedOn {
        id
        name
      }
      tailoringProcess {
        questions {
          __typename
          ...RadioQuestionFragment
          ...CheckboxQuestionFragment
        }
        buildingBlocks {
          ...BuildingBlockFragment
        }
      }
    }
  }
`);

export const answerTemplateQuestion = graphql(`
  mutation answerTemplateQuestion($answerTemplateTailoringQuestionInput: AnswerTemplateTailoringQuestionInput!) {
    answerTemplateTailoringQuestion(answerTemplateTailoringQuestionInput: $answerTemplateTailoringQuestionInput) {
      id
      businessUnit
      name
      updatedAt
      description
      publicationStatus
      owner {
        id
        name
      }
      tailoringProcess {
        questions {
          __typename
          ...RadioQuestionFragment
          ...CheckboxQuestionFragment
        }
        buildingBlocks {
          ...BuildingBlockFragment
        }
      }
    }
  }
`);

export const tailorTemplateBuildingBlock = graphql(`
  mutation tailorTemplateBuildingBlock($tailorTemplateBuildingBlockInput: TailorTemplateBuildingBlockInput!) {
    tailorTemplateBuildingBlock(tailorTemplateBuildingBlockInput: $tailorTemplateBuildingBlockInput) {
      id
    }
  }
`);

export const tailorTemplateBuildingBlocks = graphql(`
  mutation tailorTemplateBuildingBlocks($tailorTemplateBuildingBlocksInput: [TailorTemplateBuildingBlockInput!]!) {
    tailorTemplateBuildingBlocks(tailorTemplateBuildingBlocksInput: $tailorTemplateBuildingBlocksInput) {
      id
    }
  }
`);
